"use client"

import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { DefaultImage } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export interface FieldItem {
  backgroundImage: string
  icon: string
  title: string
  website: string
  link: string
}

export interface FieldOfActivityProps extends CommonStylesProps {
  fields: FieldItem[]
}

export const FieldOfActivity: ComponentConfig<FieldOfActivityProps> = {
  label: "Tamda Group | Field of Activity",
  fields: {
    fields: {
      label: "Fields",
      type: "array",
      arrayFields: {
        backgroundImage: {
          label: "Background Image",
          type: "custom",
          render: props => <MediaSelect {...props} mediaType="image" />,
        },
        icon: {
          label: "Icon",
          type: "custom",
          render: props => <MediaSelect {...props} mediaType="image" />,
        },
        title: {
          label: "Title",
          type: "textarea",
        },
        website: {
          label: "Website",
          type: "text",
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    fields: [
      {
        backgroundImage: DefaultImage,
        icon: DefaultImage,
        title: "Field of Activity 1",
        website: "https://www.google.com",
        link: "https://www.google.com",
      },
      {
        backgroundImage: DefaultImage,
        icon: DefaultImage,
        title: "Field of Activity 2",
        website: "https://www.google.com",
        link: "https://www.google.com",
      },
    ],
    className: "",
  },
  ...RenderConfig,
}
